import React, { Component } from 'react';
import { Link, NavLink } from 'react-router-dom';
import * as Scroll from 'react-scroll';
import history from 'imports/history';
import * as auth from 'imports/auth';
import './MobileSidebar.scss';
import { sendBru_api } from "../../pages/home/HomeApi";
import Modal from "react-modal";


const customStyles = {
    content: {
        top: "50%",
        left: "50%",
        right: "auto",
        bottom: "auto",
        marginRight: "-50%",
        transform: "translate(-50%, -50%)"
    }
};


export default class MobileSidebar extends Component {
	constructor(props) {
		super(props);
	}

	state = {
		isDropDownOpen: true,
	}

	handleClickOnCourse(e) {
		e.preventDefault();
		if (this.props.isHome) {
			Scroll.scroller.scrollTo('mba', {
				duration: 500,
				smooth: true,
				offset: 50,
			});
		} else {
			history.push({
				pathname: '/home',
				search: '?go=mba',
			});
		}
	}

	handleClickOnDropDown(e) {
		e.preventDefault();
		this.setState({
			// isDropDownOpen: !this.state.isDropDownOpen,
			isDropDownOpen: true
		});
	}

    openModal() {
        this.setState({ sendStatus: "default" });
        this.setState({ mobileNumber: "" });
        this.setState({ modalBruIsOpen: true });
    }

    closeModal() {
        this.setState({ modalBruIsOpen: false });
    }

    setMobileNumber(e) {
        this.setState({ mobileNumber: e.target.value });
    }

    async sendBru(e) {
        this.setState({ spin: true });
        if(this.state.mobileNumber.length > 5) {
            try{
                const res = await sendBru_api(this.state.mobileNumber);
                this.setState({ sendStatus: "success" });
            }catch (e) {
                this.setState({ sendStatus: "error" });
            }
        }
    }





	render() {
		const { open, onClickOverlay } = this.props;
		const user = auth.getUser();
		const userIsSignedIn = (user !== null && user !== undefined);
		return (
			<aside id="mobile-sidebar" className={open ? "active" : ""}>

                <Modal
                    isOpen={this.state.modalBruIsOpen}
                    onRequestClose={e => this.closeModal()}
                    contentLabel="ضمیمه"
                    style={customStyles}
                    className=""
                >

                    <div className="float-register-modal">
                        <div className="float-register-modal-title"><span>برای دریافت بروشور لطفا شماره همراه خود را وارد نمایید</span>
                        </div>
                        <div className="bru-mobile-input"><span className="icon icon-mobile"></span>
                            <input type="text"
                                   name="" id=""
                                   placeholder="شماره موبایل"
                                   onChange={e=>this.setMobileNumber(e)}
                                   value={this.mobileNumber}
                            />
                        </div>
                        {this.state.sendStatus==="error"?
                            <div className="float-modal-error-message">
                                <span>مشکل در ارسال , مجددا سعی نمایید</span>
                            </div>:null
                        }

                        {this.state.sendStatus==="success"?
                            <div className="float-modal-success-message">
                                <span>بروشور با موفقیت برای شما ارسال شد</span>
                            </div>:null}

                        <div className="float-bru-modal-btn" onClick={e=>{
                            this.sendBru()
                        }}><span>ارسال بروشور</span></div>
                    </div>
                </Modal>

				<div className="overlay" onClick={e => {e.preventDefault();onClickOverlay()}}></div>
				<div className="menu">
					<div className="top">
						<Link to="/home">
							<img src="/images/logo.svg" className="logo" alt="derayat-logo" />
						</Link>
						{
							userIsSignedIn ? (
								<div className={this.state.isDropDownOpen ? "drop-down__btn open" : "drop-down__btn"} onClick={this.handleClickOnDropDown.bind(this)}>
									<img src={user.image || "/images/img-avatar.svg"} className="avatar" alt="avatar" />
									<span className="btn">{user.firstName + ' ' + user.lastName}
										<i className="icon icon-dr-black-arrow-left"></i>
									</span>
								</div>
							) : (
								<Link to="/login" className="btn auth-btn">
									<span>ورود / عضویت</span>
									<i className="icon icon-dr-black-arrow-left"></i>
								</Link>
							)
						}
					</div>
					{
						userIsSignedIn && (
							<ul className={this.state.isDropDownOpen ? "drop-down__list open" : "drop-down__list"}>
								<li>
									<NavLink activeClassName="current" to="/my-programs">
										<img src={"/images/laptop23.svg"} className="sidebar-icon" alt="User info" /><span>دوره‌های من</span>
									</NavLink>
								</li>
								<li>
									<NavLink activeClassName="current" to="/profile">
										<img src={"/images/ico-teacher-68px.svg"} className="sidebar-icon" alt="User info" /><span>اطلاعات کاربری</span>
									</NavLink>
								</li>
								<li>
									<NavLink className="invoice-m-item" activeClassName="current" to="/invoices">
										<img src={"/images/invoice-black.svg"} className="invoice-m-icon" alt="User invoices" /><span>صورت حساب</span>
									</NavLink>
								</li>
								<li>
									<NavLink activeClassName="current" to="/chat-list">
                                        <span id="badg">{this.props.unSeenMessages}</span>
										<img src={"/images/nav-chat-icon.svg"} className="sidebar-icon" alt="Chat box" />
										<span>صندوق پیام</span>
									</NavLink>
								</li>
								<NavLink activeClassName="current" to="/chat-list">
									{this.props.unSeenMessages!==0? (
										<span id="new-messages-count">{this.props.unSeenMessages} پیام جدید</span>
									):(
										null
									)}

								</NavLink>
								<li>
									<NavLink activeClassName="current" to="/notifications">
                                        <span id="badg">{this.props.notifications.length}</span>
										<img src={"/images/nav-notif-icon.svg"} className="sidebar-icon" alt="notif box" /><span>اعلانات</span>
									</NavLink>
								</li>

								<li>
									<NavLink activeClassName="current" to="/logout">
										<i className="sidebar-icon icon icon-dr-exit"></i><span>خروج از حساب</span>
									</NavLink>
								</li>

							</ul>
						)
					}
					<ul className="nav-menu">
						<li>
							<NavLink activeClassName="active" exact to="/home">خانه</NavLink>
						</li>
						<li>
							<NavLink activeClassName="active" exact to="/programs">دوره ها</NavLink>
						</li>
						{/* <li>
							<NavLink activeClassName="active" to="/mba-program">دوره MBA</NavLink>
						</li> */}
						<li>
							<NavLink activeClassName="active" to="/courses">درس‌ها</NavLink>
						</li>
						<li>
							<NavLink activeClassName="active" to="/faq">سوالات متداول</NavLink>
						</li>
						<li>
							<NavLink activeClassName="active" to="/about-us">درباره‌ ما</NavLink>
						</li>
                        <li>
                                        <span className="send-bru-mobile-btn" onClick={e=>{
                                            onClickOverlay()
                                            this.openModal();
                                        }}>
                                            دریافت بروشور
                                        </span>
                        </li>
						<li>
							<NavLink activeClassName="active" to="/contact">تماس با ما</NavLink>
						</li>
					</ul>
					{/* <div className="footer-menu">
						<img src="/images/namad.png" alt="e-namad" />
						<img src="/images/samandehi.png" alt="samandehi" />
					</div> */}
				</div>
			</aside>
		)
	}
}
